import { Stack } from "@mui/material";
import TableConstructor from "layout/TableConstructor";
import {
  OrderType,
  PlatformCompanyCandidateListOrderFields,
  PlatformCompanyCandidateListOrderInput,
  useCompanyCandidateListQuery,
} from "@generated/graphql";
import { RouteEnum } from "layout/TableConstructor/types";
import { useNavigate } from "react-router-dom";
import Header from "./components/Header";
import columnConfig, { CompanyCandidateItem } from "./tableConfig/columnConfig";
import filterConfig, { CompanyCandidateFilter } from "./tableConfig/filterConfig";

const CandidateListPage = () => {
  const navigate = useNavigate();

  const order: PlatformCompanyCandidateListOrderInput = {
    field: PlatformCompanyCandidateListOrderFields.CreatedAt,
    order: OrderType.Desc,
  };
  const { data, loading, refetch } = useCompanyCandidateListQuery({
    variables: {
      page: 0,
      limit: 50,
      filter: {},
      order,
    },
  });

  const candidateList = data?.companyCandidates.data || [];
  const totalCount = data?.companyCandidates.totalCount;

  return (
    <Stack>
      <Header refetchList={refetch} />
      <TableConstructor<
        CompanyCandidateItem,
        CompanyCandidateFilter,
        PlatformCompanyCandidateListOrderFields,
        undefined,
        RouteEnum.Candidate
      >
        exportRoute={RouteEnum.Candidate}
        settingsModalTitle='Список кандидатов'
        data={candidateList}
        totalCount={totalCount}
        loading={loading}
        columnsConfig={columnConfig}
        filtersConfig={filterConfig}
        emptyPlaceholderText='Пока нет кандидатов'
        refetch={refetch}
        storageName='candidateList'
        onRowClick={(row) => navigate(`view/${row.id}`)}
        defaultOrder={order}
        defaultVisibleColumnList={[
          "numericId",
          "fullName",
          "createdAt",
          "action",
          "organization",
          "position",
          "type",
          "grade",
          "email",
          "telegramUsername",
          "login",
          "phoneNumber",
          "language",
        ]}
      />
    </Stack>
  );
};

export default CandidateListPage;
